exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_featuresActionContainer__2bUFI{display:flex;flex-direction:column;width:100%;justify-content:center;align-items:center}", ""]);

// exports
exports.locals = {
	"featuresActionContainer": "style_featuresActionContainer__2bUFI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/FeatureEditor/style.less
// module id = 1975
// module chunks = 8